import PropTypes from 'prop-types';
import React from 'react';
import { Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import './ErrorAlert.css';

export const ErrorAlert = ({ children }) => (
  <span>
    {children &&
    <Alert bsStyle="danger" >
      <strong><FontAwesome name="exclamation-triangle" /></strong>&nbsp;&nbsp;&nbsp;{children}
    </Alert>
    }
  </span>
);

ErrorAlert.defaultProps = {
  children: undefined,
};

ErrorAlert.propTypes = {
  children: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/ErrorAlert/ErrorAlert.jsx